/**
 * @license
 * Powered by MaxDesign. All Rights Reserved.
 * ⚠ FR : CONTENU PROTÉGÉ PAR LES DROITS D'AUTEURS (article L. 111-1 du code de la propriété intellectuelle). Cette ressource ne peut pas être utilisée, diffusée ou exploitée sans l'approbation de ses auteurs. Pour plus d'informations, veuillez contacter admin(at)maxdesign.expert
 * ⚠ EN : CONTENT PROTECTED WITH AUTHOR COPYRIGHTS (section L. 111-1 of the intellectual property code). This resource may not be used, distributed or exploited without the approval of its authors. For any information request, please contact admin(at)maxdesign.expert
 */

MaxDesign = window.MaxDesign || class {};
Object.defineProperty(MaxDesign, 'stickyATC', { get: () => document.querySelector('sticky-atc-maxdesign') });

customElements.define(
  'sticky-atc-maxdesign',
  class StickyATC extends HTMLElement {
    constructor() {
      super();
      this.settings = JSON.parse(this.querySelector(':scope > [type="application/json"]').innerText);
      this.setVariables();
      if (!this.originalButton) return;
      this.onInit();
      this.onButtonIntersect();
      this.onFooterIntersect();
      this.onStickyATCSubmit();
      if (!this.bundle) {
        this.onStickyOptionChange();
        this.onFormOptionChange();
        this.onStickyQtyChange();
        this.onFormQtyChange();
      } else {
        this.onBundleChange();
        this.DOM.bundle.createEvent();
      }
    }

    setVariables() {
      this.originalButton = document.querySelector(this.settings.originalButton);
      this.DOM = {
        bundle: document.querySelector('bundle-maxdesign'),
        sticky: {
          qtyInput: this.querySelector('#md-sticky-atc__qty-input'),
          inputs: this.querySelectorAll('.md-sticky-atc__options-select, #md-sticky-atc__qty-input'),
          options: [...this.querySelectorAll('[sticky-option]')],
          prices: this.querySelectorAll('[data-sticky-price]'),
          cpPrices: this.querySelectorAll('[data-sticky-cp-price]'),
          btn: this.querySelector('.md-sticky-atc__action'),
          image: this.querySelector('.md-sticky-atc__image'),
          title: this.querySelector('.md-sticky-atc__title'),
        },
        form: {
          id: document.querySelectorAll('select[name="id"], input[name="id"]')[0],
          qtyInput: document.querySelectorAll(this.settings.qtyInput)[0],
          inputs: [
            ...document.querySelectorAll(
              'form[action*="/cart/add"] input:not([type="hidden"]):not([name="id"]), form[action*="/cart/add"] select:not([name="id"]), product-details input:not([type="hidden"]):not([name="id"]), product-details select:not([name="id"])'
            ),
          ],
        },
      };
    }

    /*************************
      MAIN
    *************************/

    /**
     * stickyATC init trigger input events
     */
    onInit() {
      if (!this.DOM.bundle) {
        for (let input of this.DOM.form.inputs) {
          const event = new Event('change', { bubbles: true, cancelable: true });
          event.detail = { bypassIsTrusted: true };
          input.dispatchEvent(event);
        }
      } else {
        this.bundle = true;
        this.setAttribute('sticky-mode', 'cta');
      }
      this.updateBar();
    }

    /**
     * Toggle sticky bar
     */
    onButtonIntersect() {
      let options = { threshold: 0.99, rootMargin: `${this.originalButton.offsetHeight}px 0px` };
      let observer = new IntersectionObserver(entries => {
        for (let entry of entries) this.toggleStickyPosition(!entry.isIntersecting && entry.boundingClientRect.y < 0);
      }, options);
      observer.observe(this.originalButton);
    }

    onFooterIntersect() {
      let observer = new IntersectionObserver(entries => {
        let enableFooterIntersect =
          this.isMobile(this.settings.mobile.location == 'bottom') ||
          !this.isMobile(this.settings.desktop.location == 'bottom');
        if (enableFooterIntersect && this.footerIntersectInited)
          for (let entry of entries) this.toggleStickyPosition(!entry.isIntersecting);
        this.footerIntersectInited = true;
      });
      observer.observe(this.nextElementSibling);
    }

    /*************************
      USER INTERACTION
    *************************/

    onStickyOptionChange() {
      for (let stickyOption of this.DOM.sticky.inputs) {
        stickyOption.addEventListener('change', () => {
          this.DOM.form.inputs.some(formInput => {
            if (formInput.nodeName == 'INPUT' && formInput.value == stickyOption.value) {
              formInput.checked = true;
              formInput.dispatchEvent(new Event('change', { bubbles: true }));
              formInput.dispatchEvent(new Event('input', { bubbles: true }));
              formInput.dispatchEvent(new Event('click', { bubbles: true }));
              setTimeout(this.updateBar.bind(this));
              return true;
            } else if (formInput.nodeName == 'SELECT') {
              let breakLoop = false;
              [...formInput.options].forEach(optionItem => {
                if (optionItem.value == stickyOption.value) {
                  formInput.value = optionItem.value;
                  formInput.dispatchEvent(new Event('change', { bubbles: true }));
                  setTimeout(this.updateBar.bind(this));
                  breakLoop = true;
                }
              });
              return breakLoop ? true : false;
            } else if ((formInput.nodeName == 'INPUT' && formInput.type == 'text') || formInput.type == 'number') {
              formInput.value = stickyOption.value;
              formInput.dispatchEvent(new Event('change', { bubbles: true }));
              setTimeout(this.updateBar.bind(this));
              return true;
            }
          });
        });
      }
    }

    onFormOptionChange() {
      for (let formInput of this.DOM.form.inputs) {
        formInput.addEventListener('change', e => {
          if (e.isTrusted || (e.detail && e.detail.bypassIsTrusted)) {
            setTimeout(() => {
              this.DOM.sticky.options.some(stickyOption => {
                if (stickyOption.nodeName == 'OPTION' && stickyOption.value == formInput.value) {
                  stickyOption.selected = 'selected';
                  setTimeout(this.updateBar.bind(this));
                  return true;
                } else if (stickyOption.nodeName == 'INPUT' && !isNaN(formInput.value)) {
                  e.preventDefault();
                  e.stopPropagation();
                  stickyOption.value = formInput.value;
                  setTimeout(this.updateBar.bind(this));
                  return true;
                }
              });
            });
          }
        });
      }
    }

    onStickyQtyChange() {
      let input = this.DOM.sticky.qtyInput;
      input.previousElementSibling.addEventListener('click', () => {
        input.stepDown();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      input.nextElementSibling.addEventListener('click', () => {
        input.stepUp();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    onFormQtyChange() {
      let input = this.DOM.form.qtyInput;
      if (input) {
        let qtyBtns = [input.previousElementSibling, input.nextElementSibling];
        for (let btn of qtyBtns)
          btn.addEventListener('click', () => {
            let event = new Event('change', { bubbles: true });
            event.detail = { bypassIsTrusted: true };
            input.dispatchEvent(event);
          });
      }
    }

    onBundleChange() {
      document.body.addEventListener('bundle:change', e => {
        const bundle = e.detail;
        if (bundle.settings.bundleType == 'variants') {
          this.settings.product = bundle.data.product;
          this.updateBar();
        } else {
          if (bundle.image) this.updateImage(bundle.image);
          this.updatePrices(bundle.price, bundle.comparePrice);
          const btnContent = bundle.variant.available ? this.settings.atcText : this.originalButton.textContent;
          this.updateBtn(btnContent);
          this.setAttribute('sticky-variant-available', bundle.variant.available);
        }
      });
    }

    onStickyATCSubmit() {
      this.DOM.sticky.btn.addEventListener('click', e => {
        const mobileLayout = this.settings.mobile.layout;
        const desktopLayout = this.settings.desktop.layout;
        if (this.isMobile(mobileLayout == 'cta') || !this.isMobile(desktopLayout == 'cta')) {
          const optionsView = document.querySelector(this.settings.formSelectors) || this.originalButton;
          optionsView.scrollIntoView({ behavior: 'smooth' });
        } else {
          this.DOM.sticky.btn.dataset.loader = 'loading';
          this.originalButton.click();
        }
      });
    }

    /*************************
      UPDATE DOM
    *************************/

    /**
     * Update bar (variant img & text)
     */
    updateBar() {
      for (let variant of this.settings.product.variants) {
        if (this.DOM.form.id.value == variant.id) {
          // update image
          const image = variant.featured_image ? variant.featured_image.src : this.settings.product.featured_image;
          this.updateImage(image);
          // update prices
          const price = this.formatMoney(variant.price);
          const cpAtPrice = variant.compare_at_price ? this.formatMoney(variant.compare_at_price) : '';
          this.updatePrices(price, cpAtPrice);
          // update bar & btn status
          const btnContent = variant.available ? this.settings.atcText : this.originalButton.textContent;
          this.updateBtn(btnContent);
          // update bar availibility status
          this.setAttribute('sticky-variant-available', variant.available);
          break;
        }
      }
    }

    /**
     * update btn
     * @param {string} content - btn content
     */
    updateBtn(content) {
      this.DOM.sticky.btn.firstElementChild.textContent = content;
    }

    /**
     * update sticky image
     * @param {string} image - image
     */
    updateImage(image) {
      this.DOM.sticky.image.src = image.replace(/(\.[^\.]+)$/, '_small$1');
    }

    /**
     * update sticky title
     * @param {string} title - title
     */
    updateTitle(title) {
      this.DOM.sticky.title.textContent = title;
    }

    /**
     * update sticky prices
     * @param {string} price - formated Prices
     * @param {string} cpAtPrice - formated cpPrice
     */
    updatePrices(price, cpAtPrice) {
      for (let i = 0; i < 2; i++) {
        this.DOM.sticky.prices[i].textContent = price;
        this.DOM.sticky.cpPrices[i].textContent = cpAtPrice;
      }
    }

    /*************************
      HELPER METHODS
    *************************/

    /**
     * set sticky bar position style
     * @param {Boolean} show - toggle hide / show
     */
    toggleStickyPosition(show) {
      this.style[this.isMobile() ? this.settings.mobile.location : this.settings.desktop.location] = show
        ? 0
        : '-125px';
    }

    /**
     * Check if medium is mobile
     */
    get isMobile() {
      return (param = true) => matchMedia(`(max-width:767px)`).matches && param;
    }

    /**
     * Money formater
     */
    formatMoney(cents) {
      const { moneyFormat } = this.settings;
      const regex = /\{\{\s*(\w+)\s*\}\}/;
      const placeholder = moneyFormat.match(regex)[1];
      const [precision, thousands, decimal] = {
        amount: [2, ',', '.'],
        amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','],
        amount_no_decimals_with_comma_separator: [0, '.', ','],
      }[placeholder];
      const formatWithDelimiters = number => {
        if (isNaN(number) || number === null) return 0;
        const fixedNumber = (number / 100.0).toFixed(precision);
        const [dollars, cents] = fixedNumber.split('.');
        const thousandsRegex = /(\d)(?=(\d{3})+$)/g;
        return dollars.replace(thousandsRegex, `$1${thousands}`) + (cents ? decimal + cents : '');
      };
      const value = formatWithDelimiters(typeof cents === 'string' ? cents.replace('.', '') : cents);
      return moneyFormat.replace(regex, value);
    }
  }
);
